import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import WebinarSessionDateTimeInterface from 'common/types/entities/WebinarSessionDateTimeInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createWebinarSessionDateTime(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): WebinarSessionDateTimeInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.WebinarSessionDateTime,
      parentId,
      masterBlockId,
    ),
    padding: {
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 10,
      paddingRight: 10,
    },
    mobilePadding: {
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 10,
      paddingRight: 10,
    },
    fontSize: 18,
    iconFontSize: 20,
  }
}
